import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\FileController::acceptSuggestion
* @see Http/Controllers/FileController.php:91
* @route '/projects/{project}/files/{file}/accept-suggestion'
*/
export const acceptSuggestion = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: acceptSuggestion.url(args, options),
    method: 'post',
})

acceptSuggestion.definition = {
    methods: ["post"],
    url: '/projects/{project}/files/{file}/accept-suggestion',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FileController::acceptSuggestion
* @see Http/Controllers/FileController.php:91
* @route '/projects/{project}/files/{file}/accept-suggestion'
*/
acceptSuggestion.url = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            file: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return acceptSuggestion.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::acceptSuggestion
* @see Http/Controllers/FileController.php:91
* @route '/projects/{project}/files/{file}/accept-suggestion'
*/
acceptSuggestion.post = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: acceptSuggestion.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::acceptSuggestion
* @see Http/Controllers/FileController.php:91
* @route '/projects/{project}/files/{file}/accept-suggestion'
*/
const acceptSuggestionForm = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: acceptSuggestion.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::acceptSuggestion
* @see Http/Controllers/FileController.php:91
* @route '/projects/{project}/files/{file}/accept-suggestion'
*/
acceptSuggestionForm.post = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: acceptSuggestion.url(args, options),
    method: 'post',
})

acceptSuggestion.form = acceptSuggestionForm

/**
* @see \App\Http\Controllers\FileController::rejectSuggestion
* @see Http/Controllers/FileController.php:107
* @route '/projects/{project}/files/{file}/reject-suggestion'
*/
export const rejectSuggestion = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rejectSuggestion.url(args, options),
    method: 'post',
})

rejectSuggestion.definition = {
    methods: ["post"],
    url: '/projects/{project}/files/{file}/reject-suggestion',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FileController::rejectSuggestion
* @see Http/Controllers/FileController.php:107
* @route '/projects/{project}/files/{file}/reject-suggestion'
*/
rejectSuggestion.url = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            file: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return rejectSuggestion.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::rejectSuggestion
* @see Http/Controllers/FileController.php:107
* @route '/projects/{project}/files/{file}/reject-suggestion'
*/
rejectSuggestion.post = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rejectSuggestion.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::rejectSuggestion
* @see Http/Controllers/FileController.php:107
* @route '/projects/{project}/files/{file}/reject-suggestion'
*/
const rejectSuggestionForm = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rejectSuggestion.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::rejectSuggestion
* @see Http/Controllers/FileController.php:107
* @route '/projects/{project}/files/{file}/reject-suggestion'
*/
rejectSuggestionForm.post = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rejectSuggestion.url(args, options),
    method: 'post',
})

rejectSuggestion.form = rejectSuggestionForm

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
export const download = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/files/{file}/download',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
download.url = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            file: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return download.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
download.get = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
download.head = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
const downloadForm = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
downloadForm.get = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::download
* @see Http/Controllers/FileController.php:121
* @route '/projects/{project}/files/{file}/download'
*/
downloadForm.head = (args: { project: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

download.form = downloadForm

const files = {
    acceptSuggestion: Object.assign(acceptSuggestion, acceptSuggestion),
    rejectSuggestion: Object.assign(rejectSuggestion, rejectSuggestion),
    download: Object.assign(download, download),
}

export default files